export default {
  curl (context, api, route, headers, parameters = {}) {
    var body = {
      api: api,
      route: route,
      headers: headers,
      parameters: parameters
    }
    context.$http.post('curl', body).then(response => {
      context.curl = response.body
      context.curl.response = JSON.stringify(response.body.response, null, 2)
    })
  },

  catalog (context, session) {
    var headers = {'X-Authentication': session}
    this.curl(context, 'nlife/v3', 'catalog_url', headers)
  },

  purchases (context, session) {
    var headers = {'X-Authentication': session}
    this.curl(context, 'nlife/v3', 'insecure_purchases_url', headers)
  }
}



// WEBPACK FOOTER //
// ./src/services/curl.js